import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { CardInputsContainer, EditIcon } from "~/common/components";
import Modal from "~/common/components/Modal";
import { SchedulingMethodsTable } from "~/common/components/SchedulingMethodsTable";
import { useCurrentTeamMemberContext } from "~/providers/hooks";
import { useGetSchedulingMethods } from "~/providers/hooks/useGetSchedulingMethods";
import { SchedulingMethodsForm } from "./SchedulingMethodsForm";

export const SchedulingMethods = () => {
  const [isEditing, setEditing] = useState<boolean>(false);
  const queryClient = useQueryClient();
  const teamMember = useCurrentTeamMemberContext();
  const organizationId =
    teamMember.organization_team_members[0].organization.id;
  const { data } = useGetSchedulingMethods(organizationId, !!organizationId);

  const onSuccess = () => {
    void queryClient.invalidateQueries({
      queryKey: ["scheduling-methods", organizationId],
    });

    setEditing(false);
  };

  return (
    <CardInputsContainer
      title="Appointment scheduling"
      actions={
        <button onClick={() => setEditing(true)}>
          <EditIcon />
        </button>
      }
    >
      <p className="pb-2 pt-1">
        To include scheduling as part of the consultation workflow, please
        specify at least one appointment scheduling method.
      </p>
      <div className="overflow-x-auto">
        <SchedulingMethodsTable data={data} />
      </div>

      <Modal
        title="Scheduling options"
        show={isEditing}
        onClose={() => setEditing(false)}
        className="max-h-[90vh] max-w-xl overflow-auto text-sm text-gray-700 sm:w-4/5 md:w-2/3 xl:w-2/3"
      >
        <p>
          Specify at least one method for patients to schedule appointments.
        </p>
        <SchedulingMethodsForm
          defaultValues={data}
          onSuccess={onSuccess}
          onCancel={() => setEditing(false)}
        />
      </Modal>
    </CardInputsContainer>
  );
};
